import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  static targets = ["button", "nameInput", "doName", "signature", "restartBtn"];

  handleManager() {
    this.signatureTarget.classList.toggle("d-none");
    this.restartBtnTarget.classList.toggle("d-none");
    this.buttonTarget.disabled = !this.buttonTarget.disabled;
    this.nameInputTarget.value = this.doNameTarget.innerText;
  }
}
